import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Events, Platform } from 'ionic-angular';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthProvider } from '../../providers/auth/auth';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { PrestartPage } from '../prestart/prestart';
import { HomePage } from '../home/home';
import { CabsandPrestartPage } from '../cabsand-prestart/cabsand-prestart';
import { KlmrNewsPage } from '../klmr-news/klmr-news';
import { CabsandNewsPage } from '../cabsand-news/cabsand-news';
import { KlmrDashboardPage } from '../klmr-dashboard/klmr-dashboard';
import { CabsandDashboardPage } from '../cabsand-dashboard/cabsand-dashboard';
import { AppVersion } from '@ionic-native/app-version';
import { CrudProvider } from '../../providers/crud/crud';

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  credentialsForm: FormGroup;
  companyName: any = "";
  appCurrentVersion: any = null;;
  selectOptions: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, private formBuilder: FormBuilder, public auth: AuthProvider, public events: Events, public utiltiy: UtiltiyProvider, public appVersion: AppVersion, public platform: Platform, public api: CrudProvider) {
    this.getCompanyName();
    this.getAppVeersion();
    this.navCtrl.swipeBackEnabled = false;
    this.credentialsForm = this.formBuilder.group({
      username: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required]),
    });
    this.selectOptions = {
      mode: 'ios'
    };
  }

  async getCompanyName() {
    let currentGroup = await this.utiltiy.getStorage("currentClass");
    console.log("currentGroup", currentGroup);
    if (currentGroup) {

      this.companyName = currentGroup;
      this.events.publish('currentClass', currentGroup);
    }
  }



  login() {
    console.log("this.credentialsForm.value", this.credentialsForm.value)
    let formData: FormData = new FormData();
    formData.append('username', this.credentialsForm.value.username);
    formData.append('password', this.credentialsForm.value.password);
    this.utiltiy.startLoading();
    this.auth.login(formData)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();

        if (result.data) {
          this.utiltiy.toaster(result.message);
          this.utiltiy.setStorage("token", result.token);
          this.utiltiy.setStorage("roleID", result.data.roleID);
          this.utiltiy.setStorage("roleName", result.data.roleName);
          this.utiltiy.setStorage("userId", result.data.id);
          this.utiltiy.setStorage("name", result.data.firstName + " " + result.data.surname);
          this.utiltiy.setStorage("permissions", JSON.stringify(result.data.permissions_role));
          this.utiltiy.setStorage("primaryColor", "#b71464");
          this.events.publish('chnageSideMenu', result.data.roleID);
          this.events.publish('currentClass', this.companyName);
          this.events.publish('currentPermission', result.data.permissions_role);
          // setTimeout(() => {
          this.goTo();
          // }, 500);

        }
      }, err => {
        console.log("err", err.error.message)
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }

  async goTo() {
    let currentGroup = await this.utiltiy.getStorage("currentClass");
    if (currentGroup == "klmr") {
      // this.navCtrl.setRoot(KlmrDashboardPage);
      this.navCtrl.setRoot(KlmrNewsPage);
    } else if (currentGroup == "cabsand") {
      // this.navCtrl.setRoot(CabsandDashboardPage);
      this.navCtrl.setRoot(CabsandNewsPage);
    }
  }

  getAppVeersion() {
    if (this.platform.is('mobileweb') || this.platform.is('core')) {
      // this.biometricAvailable = true;
      // this.getLatesVersion();

      return this.appCurrentVersion;

    }
    this.appVersion.getVersionNumber()
      .then(async (result) => {
        this.appCurrentVersion = result;
        this.events.publish('appVersion', result);
        this.getLatesVersion();


      });
  }

  async getLatesVersion() {
    this.api.get("/App_Version/App_Version", "false")
      .then((result: any) => {
        if (result.status) {
          let applatestversion = result.result[0].app_version;

          let appCurrentVersion = this.appCurrentVersion.replaceAll('.', ''); 
           applatestversion = applatestversion.replaceAll('.', '');
          appCurrentVersion = parseInt(appCurrentVersion);
          applatestversion = parseInt(applatestversion);
          if(appCurrentVersion < applatestversion){

            if (this.platform.is('mobileweb') || this.platform.is('core')) {
              this.events.publish('currentVersion', true);
      
            }else{
              this.events.publish('currentVersion', true);
            }
          }else{
            console.log("no update required");
          }

          // if (this.appCurrentVersion != applatestversion) {
          //   this.events.publish('currentVersion', true);
          // }
        }

        console.log("result ", result)
      }, err => {
      })
  }

  selectType(type) {
    console.log("typw", this.companyName);
    this.utiltiy.setStorage("currentClass", type);
    this.events.publish('currentClass', type);

  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts